import React from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";
import PropTypes from "prop-types";

const AddressComponent = ({ address, label, handleChange, required }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Typography variant="h6" gutterBottom>
        {label || "Address"}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Street"
            name="street"
            value={address?.street || ""}
            onChange={handleChange}
            required={required}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="City"
            name="city"
            value={address?.city || ""}
            onChange={handleChange}
            required={required}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="State"
            name="state"
            value={address?.state || ""}
            onChange={handleChange}
            required={required}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Zip Code"
            name="postal_code"
            value={address?.postal_code || ""}
            onChange={handleChange}
            required={required}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Country"
            name="country"
            value={address?.country || "USA"}
            onChange={handleChange}
            required={required}
          />
        </Grid>
        {/* Latitude & Longitude Fields */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Latitude"
            name="latitude"
            value={address?.latitude || ""}
            onChange={handleChange}
            required={required}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Longitude"
            name="longitude"
            value={address?.longitude || ""}
            onChange={handleChange}
            required={required}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

AddressComponent.propTypes = {
  address: PropTypes.shape({
    street: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postal_code: PropTypes.string,
    country: PropTypes.string,
    latitude: PropTypes.string,
    longitude: PropTypes.string,
  }).isRequired,
  label: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
};

export default AddressComponent;
